import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { QualificationSchemeInvitees, useQualificationSchemeInvitees } from "./QualificationSchemeInvitees";

interface Props {
  eventId: string;
  onClose: () => void;
  onConfirmed: () => Promise<void> | void;
}

export const OpenSchemeCompetitionModal = ({ eventId, onClose, onConfirmed }: Props) => {
  const { t } = useTranslation();
  const { data, isFetching, isError } = useQualificationSchemeInvitees(eventId);
  const [isOpening, setIsOpening] = useState(false);
  const listIsCurrent = !isFetching && !isError && data != null;
  const canOpen = listIsCurrent && data.invitees.length > 0;

  const open = async () => {
    setIsOpening(true);
    try {
      await onConfirmed();
      onClose();
    } finally {
      setIsOpening(false);
    }
  };

  return (
    <Modal isOpen onClose={isOpening ? () => undefined : onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("Open the competition for tenders?")}</ModalHeader>
        <ModalCloseButton isDisabled={isOpening} />
        <ModalBody>
          <QualificationSchemeInvitees eventId={eventId} />
          <Text mt="4" fontSize="sm" color="smMuted">
            {t("The invitations are sent at once, and the list of invited suppliers is fixed.")}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isOpening}>
            {t("Cancel")}
          </Button>
          <Button variant="outline" colorScheme="teal" onClick={open} isLoading={isOpening} isDisabled={!canOpen}>
            {t("Open for tenders")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
